export default {
  tabs: {
    home: "Início",
    browse: "Explorar",
    trends: "Tendências",
    myPicks: "Minhas escolhas",
    leagues: "Ligas",
  },
  common: {
    viewAll: "Ver tudo",
    operator: "Operador",
    priceComparison: "Comparação de odds",
    linematePlus: "Linemate+",
    joinLinematePlus: "Entrar no Linemate+",
    actions: {
      apply: "Aplicar",
      clearAll: "Limpar tudo",
      gotIt: "Entendi",
      cancel: "Cancelar",
      close: "Fechar",
      openSettings: "Abrir ajustes",
      continue: "Continuar",
      claim: "Resgatar",
      visitPartner: "Visitar parceiro",
      alreadyHaveAccount: "Já tenho uma conta",
      edit: "Editar",
      done: "Concluído",
      save: "Salvar",
      changePassword: "Alterar senha",
      submit: "Enviar",
      resendCode: "Reenviar código",
      getStarted: "Começar",
      continueWithApple: "Continuar com Apple",
      continueWithGoogle: "Continuar com Google",
      continueWithEmail: "Continuar com e-mail",
      selectLocation: "Selecionar localização",
      showMore: "Mostrar mais",
    },
    labels: {
      player: "Jogador",
      team: "Equipe",
      firstName: "Nome",
      lastName: "Sobrenome",
      username: "Nome de usuário",
      email: "E-mail",
      password: "Senha",
      emailAddress: "Endereço de e-mail",
      confirmPassword: "Confirmar senha",
      code: "Código",
      preferredOdds: "Odds preferidas",
    },
    placeholders: {
      emailAddress: "Digite seu endereço de e-mail...",
      password: "Digite sua senha...",
    },
    errors: {
      genericTryAgainLater: "Algo deu errado. Tente novamente mais tarde.",
      noInternetConnection: "Sem conexão com a internet",
    },
    search: {
      teamOrPlayerPlaceholder: "Busque uma equipe ou jogador...",
    },
    affiliate: {
      claimYourOffer: "Resgate sua oferta da {{operator}}",
    },
    advancedTools: {
      startingLineups: "Escalações iniciais",
      startingPitchers: "Arremessadores titulares",
      weatherReport: "Relatório do tempo",
    },
    toasts: {
      addedToMyPicks: "Adicionado às Minhas escolhas",
      alreadyInMyPicks: "Já está em Minhas escolhas",
    },
    hints: {
      goToMyPicks: "Vá para Minhas escolhas para fazer sua aposta.",
    },
    profile: {
      completeYourProfile: "Complete seu perfil",
    },
    bonuses: "Bônus",
    statHeaders: {
      "+/-": "+/-",
      "1B": "1B",
      "1D": "1D",
      "1PT": "1PT",
      "20/40": "20/40",
      "2B": "2B",
      "2PT": "2PT",
      "2YELRED": "2YELRED",
      "3B": "3B",
      "3D%": "3D%",
      "3PT%": "3PT%",
      "3PTA": "3PTA",
      "3PTM": "3PTM",
      "4D%": "4D%",
      "40/20": "40/20",
      "A": "A",
      "AB": "AB",
      "AST": "AST",
      "AVG": "AVG",
      "B": "B",
      "BB": "BB",
      "BK": "BK",
      "BLK": "BLK",
      "C%": "C%",
      "CA": "CA",
      "CF%": "CF%",
      "CFK": "CFK",
      "CM": "CM",
      "COR": "COR",
      "CR%": "CR%",
      "CS": "CS",
      "D": "D",
      "DHR": "DHR",
      "DP": "DP",
      "DR": "DR",
      "DRI": "DRI",
      "DSAV": "DSAV",
      "EFG%": "eFG%",
      "ER": "ER",
      "ERA": "ERA",
      "FG": "FG",
      "FG%": "FG%",
      "FGA": "FGA",
      "FGM": "FGM",
      "FLS": "FLS",
      "FT%": "FT%",
      "FTA": "FTA",
      "FTM": "FTM",
      "FUML": "FUML",
      "G": "G",
      "GA": "GS",
      "GK": "GK",
      "GP": "J",
      "OPP": "ADV",
      "H": "H",
      "HO": "HO",
      "HR": "HR",
      "HU": "HU",
      "INT": "INT",
      "ISO": "ISO",
      "IS": "IS",
      "K": "K",
      "KM": "KM",
      "KR": "KR",
      "KRM": "KRM",
      "L": "D",
      "LB": "LB",
      "LOP": "LOP",
      "M": "M",
      "MI50": "MI50",
      "MIN": "MIN",
      "OBP": "OBP",
      "OFF": "OFF",
      "OPS": "OPS",
      "P": "P",
      "PAS": "PAS",
      "PASS ATT": "PASS ATT",
      "PASS COMP": "PASS COMP",
      "PASS RTG": "PASS RTG",
      "PASS TD": "PASS TD",
      "PASS YDS": "PASS YDS",
      "PASS YDS/ATT": "PASS YDS/ATT",
      "PASS RZ ATT": "PASS RZ ATT",
      "PASS RZ COMPL": "PASS RZ COMPL",
      "PASS RZ TD": "PASS RZ TD",
      "PCRM": "PCRM",
      "PIM": "PIM",
      "PLAYS": "PLAYS",
      "POS": "POS",
      "POS%": "POS%",
      "PP%": "PP%",
      "PPG": "PPG",
      "PPP": "PPP",
      "PS": "PS",
      "PTS": "PTS",
      "R": "R",
      "RBI": "RBI",
      "REB": "REB",
      "REC": "REC",
      "REC TGT": "REC TGT",
      "REC TD": "REC TD",
      "REC YDS": "REC YDS",
      "REC YDS/REC": "REC YDS/REC",
      "REC 100+ YDS": "REC 100+ YDS",
      "REC RZ TGT": "REC RZ TGT",
      "REC RZ REC": "REC RZ REC",
      "REC RZ TD": "REC RZ TD",
      "RED": "CV",
      "RM": "RM",
      "RUSH ATT": "RUSH ATT",
      "RUSH LONG": "RUSH LONG",
      "RUSH TD": "RUSH TD",
      "RUSH YDS": "RUSH YDS",
      "RUSH YDS/ATT": "RUSH YDS/ATT",
      "RUSH 100+ YDS": "RUSH 100+ YDS",
      "RUSH RZ ATT": "RUSH RZ ATT",
      "RUSH RZ TD": "RUSH RZ TD",
      "RZ%": "RZ%",
      "S": "S",
      "S%": "S%",
      "SA": "SA",
      "SAT": "SAT",
      "SAV": "SAV",
      "SAVES": "SAVES",
      "SHG": "SHG",
      "SH%": "SH%",
      "SHO": "SHO",
      "SHP": "SHP",
      "SHUTOUTS": "SHUTOUTS",
      "SK": "SK",
      "SLG": "SLG",
      "SO": "SO",
      "SOG": "SOG",
      "SOT": "SOT",
      "STL": "STL",
      "SV": "SV",
      "SV%": "SV%",
      "T": "T",
      "TA": "TA",
      "TB": "TB",
      "TCK": "TCK",
      "TD": "TD",
      "TO": "TO",
      "TOI": "TOI",
      "TRB": "REB",
      "TS%": "TS%",
      "USAGE %": "USAGE %",
      "W": "V",
      "WHIP": "WHIP",
      "WINS": "V",
      "XPA": "XPA",
      "XPM": "XPM",
      "XP%": "XP%",
      "YDS": "YDS",
      "YEL": "CA",
      "FG (0-19)": "FG (0-19)",
      "FG (20-29)": "FG (20-29)",
      "FG (30-39)": "FG (30-39)",
      "FG (40-49)": "FG (40-49)",
      "FG (50+)": "FG (50+)",
      "300+ YDS": "300+ YDS",
    },
    sportStatHeaders: {
      "soccer": {
        "team": {
          "Running performance (per match)": "Desempenho de corrida (por jogo)",
          "Distance covered": "Distância percorrida",
          "Number of sprints": "Número de sprints",
          "Attacking": "Ataque",
          "Goals per game": "Golos por jogo",
          "Penalty goals": "Golos de penálti",
          "Free kick goals": "Golos de livre",
          "Goals from inside the box": "Golos dentro da área",
          "Goals from outside the box": "Golos fora da área",
          "Left-footed goals": "Golos de pé esquerdo",
          "Right-footed goals": "Golos de pé direito",
          "Headed goals": "Golos de cabeça",
          "Big chances per game": "Grandes oportunidades por jogo",
          "Big chances missed per game": "Grandes oportunidades falhadas por jogo",
          "Total shots per game": "Total de remates por jogo",
          "Shots on target per game": "Remates enquadrados por jogo",
          "Shots off target per game": "Remates não enquadrados por jogo",
          "Blocked shots per game": "Remates bloqueados por jogo",
          "Succ. dribbles per game": "Dribles bem-sucedidos por jogo",
          "Corners per game": "Cantos por jogo",
          "Free kicks per game": "Livres por jogo",
          "Hit woodwork": "Aos ferros",
          "Counter attacks": "Contra-ataques",
          "Passes": "Passes",
          "Ball possession": "Posse de bola",
          "Accurate passes": "Passes precisos",
          "Acc. own half": "Eficácia no próprio meio-campo",
          "Acc. opposition half": "Eficácia no meio-campo adv.",
          "Acc. long balls": "Bolas longas precisas",
          "Acc. crosses": "Cruzamentos precisos",
          "Defending": "Defesa",
          "Clean sheets": "Jogos sem sofrer golos",
          "Goals conceded per game": "Golos sofridos por jogo",
          "Tackles per game": "Cortes por jogo",
          "Interceptions per game": "Interceções por jogo",
          "Clearances per game": "Alívios por jogo",
          "Saves per game": "Defesas por jogo",
          "Balls recovered per game": "Bolas recuperadas por jogo",
          "Errors leading to shot": "Erros que originaram remates",
          "Errors leading to goal": "Erros que deram em golo",
          "Penalties committed": "Penáltis cometidos",
          "Penalty goals conceded": "Golos de penálti sofridos",
          "Clearance off line": "Alívio na linha de golo",
          "Last man tackle": "Corte do último homem",
          "Other": "Outros",
          "Duels won per game": "Duelos ganhos por jogo",
          "Ground duels won": "Duelos no solo ganhos",
          "Aerial duels won": "Duelos aéreos ganhos",
          "Possession lost per game": "Perdas de posse por jogo",
          "Throw-ins per game": "Lançamentos laterais por jogo",
          "Goal kicks per game": "Pontapés de baliza por jogo",
          "Offsides per game": "Foras de jogo por jogo",
          "Fouls per game": "Faltas por jogo",
          "Yellow cards per game": "Cartões amarelos por jogo",
          "Red cards": "Cartões vermelhos"
        },
        "player": {
          "Matches": "Jogos",
          "Appearances": "Presenças",
          "Started": "A titular",
          "Minutes per game": "Minutos por jogo",
          "Total minutes played": "Total de minutos jogados",
          "Team of the week": "Equipa da semana",
          "Running performance (per 90)": "Desempenho de corrida (por 90)",
          "Top speed": "Velocidade máxima",
          "Goals": "Golos",
          "Expected goals (xG)": "Golos esperados (xG)",
          "Scoring frequency (in minutes)": "Frequência de golos (em minutos)",
          "Total shots": "Total de remates",
          "Shots on target per game": "Shots on target per game",
          "Big chances missed": "Grandes oportunidades falhadas",
          "Goal conversion": "Percentagem de golos",
          "Penalty conversion": "% de penáltis convertidos",
          "Free kick conversion": "Eficácia em golos de livre",
          "Penalty won": "Penálti conquistado",
          "Passing": "Passe",
          "Assists": "Assistências",
          "Expected assists (xA)": "Assistências esperadas (xA)",
          "Touches": "Toques",
          "Big chances created": "Grandes oportunidades criadas",
          "Key passes": "Passes decisivos",
          "Long balls (accurate)": "Bolas longas (precisas)",
          "Accurate chip passes": "Passes tensos precisos",
          "Interceptions": "Interceções",
          "Possession won (final third)": "Posses de bola ganhas no último terço",
          "Dribbled past per game": "Dribles sofridos por jogo",
          "Other (per game)": "Outros (por jogo)",
          "Succ. dribbles": "Dribles bem-sucedidos",
          "Total duels won": "Total de duelos ganhos",
          "Possession lost": "Perdas de posse",
          "Was fouled": "Faltas sofridas",
          "Offsides": "Foras de jogo",
          "Cards": "Cartões",
          "Yellow": "Amarelo",
          "Red (2 yellows)": "Vermelho (2 amarelos)",
          "Red": "Vermelho"
        }
      },
      "hockey": {
        "team": {
          "Game overview": "Visão geral do jogo",
          "Shots on goal": "Remates enquadrados",
          "Penalties": "Penalizações",
          "Penalty minutes": "Minutos de penalização",
          "Hits": "Contactos físicos",
          "Blocked shots": "Remates bloqueados",
          "Takeaways": "Recuperações de disco",
          "Giveaways": "Perdas de disco",
          "Empty net goals": "Golo de baliza aberta",
          "Power play %": "% de vantagem numérica",
          "Faceoffs won": "Faceoffs ganhos",
          "Game Shotmap": "Mapa de remates do jogo",
          "Select shot type in shotmap": "Select shot type in shotmap",
          "Special teams": "Equipas especiais",
          "Power play shot %": "% de remates em vantagem numérica",
          "Shorthanded shot %": "% de remates em desvantagem numérica",
          "Even strength shot %": "% de remates em igualdade numérica",
          "Power play faceoffs": "Faceoffs em vantagem numérica",
          "Shorthanded faceoffs": "Faceoffs em desvantagem numérica",
          "Even strength faceoffs": "Faceoffs em igualdade numérica",
          "5v4 conversion": "Conversão em 5x4",
          "Shots": "Remates",
          "Wrist": "Pulso",
          "Slap": "Slap",
          "Backhand": "Backhand",
          "Tip": "Tip",
          "Snap": "Snap",
          "Advanced stats": "Estatísticas avançadas",
          "Corsi %": "% de Corsi",
          "Fenwick %": "% de Fenwick",
          "Average shot distance": "Distância média dos remates"
        },
        "player": {
          "Overall": "Geral",
          "Games played": "Jogos realizados",
          "Average time on ice": "Média de tempo no gelo",
          "Goals": "Golos",
          "Assists": "Assistências",
          "Points": "Pontos",
          "Plus/minus": "Mais/menos",
          "Shots on goal": "Remates enquadrados",
          "Shooting percentage": "Percentagem de remates",
          "Game winning goals": "Golos da vitória",
          "Overtime goals": "Golos no prolongamento",
          "Defensive": "Defensivos",
          "Penalty minutes": "Minutos de penalização",
          "Blocked shots": "Remates bloqueados",
          "Hits": "Contactos físicos",
          "Power play": "Vantagem numérica",
          "Powerplay average time on ice": "Tempo médio no gelo em vantagem numérica",
          "Power play goals": "Golos em vantagem numérica",
          "Power play assists": "Assistências em vantagem numérica",
          "Power play points": "Pontos em vantagem numérica",
          "Shorthanded": "Desvantagem numérica",
          "Shorthanded average time on ice": "Tempo médio no gelo em desvantagem numérica",
          "Shorthanded goals": "Golos em desvantagem numérica",
          "Shorthanded assists": "Assistências em desvantagem numérica",
          "Shorthanded points": "Pontos em desvantagem numérica",
          "Shorthanded shots": "Remates em desvantagem numérica",
          "Even-strength": "Igualdade numérica",
          "Even strength average time on ice": "Tempo médio no gelo em igualdade numérica",
          "Faceoff": "Faceoff",
          "Faceoffs taken": "Faceoffs realizados",
          "Faceoffs won": "Faceoffs ganhos",
          "Faceoff win percentage": "Percentagem de faceoffs ganhos"
        }
      },
      "baseball": {
        "AB": "Vezes ao taco",
        "R": "Runs",
        "H": "Hits",
        "RBI": "Corridas impulsionadas",
        "HR": "Home runs",
        "BB": "Walks",
        "K": "Strikeouts",
        "AVG": "Média de rebatidas",
        "OBP": "% de presença em base",
        "SLG": "% de slugging",
        "OPS": "Presença em base mais slugging",
        "IP": "Innings lançados",
        "ERA": "Média de earned runs",
        "H_ALLOWED": "Hits sofridos",
        "R_ALLOWED": "Runs sofridas",
        "ER": "Earned runs",
        "BB_ALLOWED": "Walks sofridos",
        "HR_ALLOWED": "Home runs sofridos",
        "NP": "Número de lançamentos",
        "STR": "Strikes efetuados",
        "WHIP": "Walks e hits por innings lançados",
        "PO": "Putouts",
        "A": "Assistências",
        "E": "Erros",
        "DP": "Jogadas duplas",
        "CS": "Roubo falhado",
        "SB": "Bases roubadas sofridas"
      },
      "basketball": {
        "team": {
          "Free throws": "Lances livres",
          "2 pointers": "2 pontos",
          "3 pointers": "Triplos",
          "Field goals": "Lançamentos",
          "Rebounds": "Ressaltos",
          "Defensive rebounds": "Ressaltos defensivos",
          "Offensive rebounds": "Ressaltos ofensivos",
          "Assists": "Assistências",
          "Turnovers": "Turnovers",
          "Steals": "Roubos de bola",
          "Blocks": "Abafos",
          "Fouls": "Faltas",
          "Max points in a row": "Máximo de pontos consecutivos",
          "Time spent in lead": "Tempo passado na liderança",
          "Biggest lead": "Maior vantagem"
        },
        "player": {
          "MIN": "Minutos jogados",
          "PTS": "Pontos",
          "REB": "Ressaltos",
          "AST": "Assistências",
          "STL": "Roubos de bola",
          "BLK": "Abafos",
          "PF": "Faltas pessoais",
          "TOV": "Turnovers",
          "OREB": "Ressaltos ofensivos",
          "DREB": "Ressaltos defensivos",
          "FG": "Lançamentos",
          "FG%": "% de lançamentos",
          "FT": "Lances livres",
          "FT%": "% de lances livres",
          "3P": "Triplos",
          "3P%": "Percentagem de triplos",
          "+/-": "Plus-Minus",
          "PIR": "Pontuação do índice de desempenho"
        }
      },
      "americanFootball": {
        "team": {
          "Offense": "Ataque",
          "TD": "Touchdowns",
          "FG": "Field goals",
          "NET YDS": "Total de jardas",
          "TO": "Turnovers",
          "RZ%": "Eficiência na zona vermelha",
          "1D": "First downs",
          "3D%": "Eficiência na terceira descida",
          "Passing": "Passe",
          "PASS YDS": "Jardas líquidas de passe",
          "PASS TD": "Passes para touchdowns",
          "INT THROWN": "Interceções lançadas",
          "PASS YDS/ATT": "Média de jardas de passe por tentativa",
          "PASS RZ ATT": "Tentativas de passe na zona vermelha",
          "Rushing": "Corrida",
          "RUSH ATT": "Tentativas de corrida",
          "RUSH YDS": "Jardas percorridas",
          "RUSH YDS/ATT": "Média de jardas de corrida por tentativa",
          "Rushing 1st downs": "1st downs em corrida",
          "RUSH RZ ATT": "Tentativas de corrida na zona vermelha",
          "Other": "Outros",
          "FUML": "Fumbles perdidos"
        },
        "player": {
          "PASS COMP": "Passes completos",
          "PASS ATT": "Tentativas",
          "PASS YDS": "Jardas de passe",
          "PASS TD": "Passes para touchdowns",
          "INT": "Interceções de passe",
          "PASS YDS/ATT": "Jardas de passe por tentativa",
          "PASS RTG": "Pontuação do passador",
          "RUSH ATT": "Tentativas de corrida",
          "RUSH YDS": "Jardas percorridas",
          "RUSH TD": "Touchdowns de corrida",
          "RUSH YDS/ATT": "Jardas percorridas por tentativa",
          "RUSH LONG": "Corrida mais longa",
          "REC TGT": "Targets por receção",
          "REC": "Receções",
          "REC YDS": "Jardas ganhas por receção",
          "REC TD": "Touchdowns por receção",
          "REC YDS/REC": "Jardas por receção",
          "TCK": "Placagens combinadas",
          "SK": "Sacks",
          "FUML": "Fumbles perdidos",
          "FGM": "Field goals convertidos",
          "XPM": "Pontos extra convertidos",
          "PTS": "Total de pontos"
        }
      },
      "rugby": {
        "team": {
          "Ball possession": "Posse de bola",
          "Passes": "Passes",
          "Tries": "Ensaios",
          "Try assists": "Assistências para ensaios",
          "Conversions": "Conversões",
          "Carries": "Corridas",
          "Clean breaks": "Quebras de linha defensiva",
          "Penalty goals": "Ensaios de penalidade",
          "Drop goals": "Pontapés de ressalto",
          "Scrums": "Scrums",
          "Lineouts": "Alinhamentos",
          "Turnovers": "Turnovers",
          "Turnovers won": "Turnovers ganhos",
          "Meters run": "Metros percorridos",
          "Offloads": "Offloads",
          "Tackles": "Placagens",
          "Tackles missed": "Placagens falhadas",
          "Penalties conceded": "Penalidades sofridas",
          "Red cards": "Cartões vermelhos",
          "Yellow cards": "Cartões amarelos"
        },
        "player": {
          "PTS": "Pontos",
          "TRY": "Ensaios",
          "TKL": "Placagens",
          "PG": "Ensaios de penalidade",
          "PAS": "Passes",
          "CAR": "Corridas",
          "CB": "Quebras de linha defensiva",
          "DG": "Pontapés de ressalto",
          "MR": "Metros percorridos",
          "OFF": "Offloads",
          "TM": "Placagens falhadas",
          "TA": "Assistências para ensaios",
          "TW": "Turnovers ganhos"
        }
      }
    },
    positions: {
      goalies: "Goleiros",
      skaters: "Jogadores de linha",
      pitchers: "Arremessadores",
      hitters: "Rebatedores",
      forwards: "Atacantes",
      midfielders: "Meio-campistas",
      defenders: "Defensores",
      outfielders: "Outfielders",
      players: "Jogadores",
    },
    filters: {
      titles: {
        lineType: "Tipo de linha",
        game: "Jogo",
        outcome: "O/U",
        betType: "Tipo de aposta",
        trendType: "Tipo de tendência",
        signals: "Sinais",
        season: "Temporada",
        team: "Equipe",
        minOdds: "Odds mínimas",
        timeframe: "Período",
      },
      plurals: {
        lineType: "Tipos de linha",
        game: "Jogos",
        outcome: "Resultados",
        betType: "Tipos de aposta",
        trendType: "Tipos de tendência",
        signals: "Sinais",
        season: "Temporadas",
        team: "Equipes",
      },
      options: {
        game: {
          all: "Todos os jogos",
          byGame: "Por jogo",
        },
        team: {
          all: "Todas as equipes",
        },
        lineType: {
          main: "Linhas principais",
          alternate: "Linhas alternativas",
        },
        outcome: {
          all: "Mais+Menos",
          over: "Mais",
          under: "Menos",
          yes: "Sim",
          no: "Não",
          cover: "Cobertura",
        },
        betType: {
          all: "Todos os tipos de aposta",
        },
        minOdds: {
          all: "Todas as odds",
        },
        timeframe: {
          season: "Temporada",
          playoffs: "Playoffs",
          headToHead: "Confronto direto",
          last5: "Últimos 5",
          last10: "Últimos 10",
          last20: "Últimos 20",
          last30: "Últimos 30",
        },
        splits: {
          all: "Casa+Fora",
          home: "Início",
          away: "Fora",
        },
        trendType: {
          player: "Jogador",
          team: "Equipe",
        },
        qualifier: {
          averageStats: "Por jogo",
          cumulativeStats: "Total",
        },
        signals: {
          allSignals: "Todos os sinais",
          recentForm: "Forma recente",
          headToHead: "Confronto direto",
          homeAwaySplits: "Divisões casa/fora",
          opponentRank: "Ranking do adversário",
          injuryImpact: "Impacto de lesões",
          starter: "Titular",
          weather: "Tempo",
          startingPitcher: "Arremessador titular",
        },
      },
    },
    empty: {
      checkBackLater: "Volte mais tarde.",
      pendingOdds: {
        title: "Odds pendentes",
      },
    },
  },
  betTypes: {
    ANYTIME_GOAL_SCORER: "Gols",
    ANYTIME_TOUCHDOWN: "TD a qualquer momento",
    ANYTIME_TOUCHDOWN_1Q: "TD a qualquer momento no 1Q",
    ANYTIME_TRY_SCORER: "Marcador de ensaio a qualquer momento",
    ASSISTS: "Assistências",
    ASSISTS_1Q: "Assistências no 1Q",
    ASSISTS_PLUS_REBOUNDS: "REB+AST",
    BLOCKED_SHOTS: "Chutes bloqueados",
    BLOCKS: "Bloqueios",
    BOTH_TEAMS_TO_SCORE: "Ambas equipes marcam",
    CARDS: "Cartões",
    CORNERS: "Escanteios da equipe",
    DISPOSALS: "Disposals",
    DOUBLE_CHANCE: "Dupla chance",
    DOUBLE_DOUBLE: "Double-double",
    EXTRA_POINTS_MADE: "XP convertidos",
    FIELD_GOALS_MADE: "Field goals convertidos",
    GAME_TOTAL: "Total do jogo",
    GAME_TOTAL_1H: "Total do jogo 1T",
    GAME_TOTAL_1Q: "Total do jogo 1Q",
    GAME_TOTAL_2H: "Total do jogo 2T",
    GAME_TOTAL_CARDS: "Total de cartões do jogo",
    GAME_TOTAL_FIRST_5_INNINGS: "Total do jogo nas 5 primeiras entradas",
    GOAL_OR_ASSIST: "Golo ou assistência",
    GOALS: "Gols",
    GOALS_ALLOWED: "Gols contra",
    HITTER_DOUBLES: "Duplas",
    HITTER_HITS: "Rebatidas",
    HITTER_HITS_PLUS_RUNS_PLUS_RUNS_BATTED_IN: "H+R+RBI",
    HITTER_HOME_RUNS: "HR",
    HITTER_RUNS: "Corridas",
    HITTER_RUNS_BATTED_IN: "RBI",
    HITTER_SINGLES: "Simples",
    HITTER_STOLEN_BASES: "Bases roubadas",
    HITTER_TOTAL_BASES: "Bases totais",
    HITTER_TRIPLES: "Triplas",
    INTERCEPTIONS: "Int",
    KICKING_POINTS: "Pontos de chute",
    MARKS: "Marks",
    MONEY_LINE: "Vencedor",
    MONEY_LINE_1H: "Vencedor 1T",
    MONEY_LINE_1Q: "Vencedor 1Q",
    MONEY_LINE_2H: "Vencedor 2T",
    MONEY_LINE_FIRST_5_INNINGS: "Vencedor nas 5 primeiras entradas",
    PASSING_ATTEMPTS: "Tentativas de passe",
    PASSING_COMPLETIONS: "Passes completos",
    PASSING_PLUS_RUSHING_YARDS: "Jardas de passe + corrida",
    PASSING_PLUS_RUSHING_YARDS_1Q: "1Q jardas de passe + corrida",
    PASSING_TOUCHDOWNS: "Passes para touchdown",
    PASSING_YARDS: "Jardas de passe",
    PASSING_YARDS_1Q: "1Q jardas de passe",
    PITCHER_EARNED_RUNS: "Corridas merecidas",
    PITCHER_HITS_ALLOWED: "Rebatidas permitidas",
    PITCHER_OUTS: "Eliminações do arremessador",
    PITCHER_STRIKEOUTS: "Strikeouts",
    PITCHER_WALKS_ALLOWED: "Walks permitidos",
    POINTS: "Pontos",
    POINTS_1Q: "Pontos 1Q",
    POINTS_PLUS_ASSISTS: "PTS+AST",
    POINTS_PLUS_ASSISTS_PLUS_REBOUNDS: "PTS+AST+REB",
    POINTS_PLUS_REBOUNDS: "PTS+REB",
    POWERPLAY_POINTS: "Pontos em power play",
    REBOUNDS: "Rebotes",
    REBOUNDS_1Q: "Rebotes 1Q",
    RECEIVING_YARDS: "Jardas recebidas",
    RECEIVING_YARDS_1Q: "1Q jardas recebidas",
    RECEPTIONS: "Recepções",
    RUN_FIRST_INNING: "Corrida na primeira entrada",
    RUSHING_ATTEMPTS: "Tentativas de corrida",
    RUSHING_PLUS_RECEIVING_YARDS: "Jardas de corrida + receção",
    RUSHING_PLUS_RECEIVING_YARDS_1Q: "1Q jardas de corrida + receção",
    RUSHING_YARDS: "Jardas corridas",
    RUSHING_YARDS_1Q: "1Q jardas corridas",
    SAVES: "Defesas",
    SHOTS: "SHO",
    SHOTS_ON_GOAL: "Chutes no gol",
    SHOTS_ON_TARGET: "Chutes no gol",
    player: {
      SHOTS_ON_TARGET: "Chutes no gol",
    },
    team: {
      SHOTS_ON_TARGET: "Chutes no gol do time",
    },
    SHUTOUT: "Shutout",
    SPREAD: "Handicap",
    SPREAD_1H: "Handicap 1T",
    SPREAD_1Q: "Handicap 1Q",
    SPREAD_2H: "Handicap 2T",
    SPREAD_FIRST_5_INNINGS: "Handicap nas 5 primeiras entradas",
    STEALS: "Roubos",
    STEALS_PLUS_BLOCKS: "STL+BLK",
    TACKLES: "Desarmes",
    TEAM_TOTAL: "Total da equipe",
    TEAM_TOTAL_1H: "Total da equipe 1T",
    TEAM_TOTAL_1Q: "Total da equipe 1Q",
    TEAM_TOTAL_2H: "Total da equipe 2T",
    TEAM_TOTAL_CARDS: "Total de cartões da equipe",
    THREE_POINTS_MADE: "3PTM",
    TRIES: "Ensaios",
    TRIPLE_DOUBLE: "Triple-double",
    TURNOVERS: "Perdas de bola",
    WIN_TO_NIL: "Vencer sem sofrer gol",
  },
};
